import React from 'react';

import {
  Container,
} from '@uncinc/uncinc-react-kitchen-sink';

import {
  Quote,
} from '../../../components';

import './style.scss';

const ParagraphQuote = ({ entity }) => {
  const name = entity.getIn(['field_name', 0, 'value']);
  const body = entity.getIn(['field_body', 0, 'processed']);
  const jobTitle = entity.getIn(['field_function', 0, 'value']);
  const linkTitle = entity.getIn(['field_link', 0, 'title']);
  const linkUri = entity.getIn(['field_link', 0, 'alias'], entity.getIn(['field_link', 0, 'uri']));
  const image = entity.getIn(['field_media_image', 0, 'styles', '1_1']);
  const imageAlt = entity.getIn(['field_media_image', 0, 'alt'], '');

  return (
    <Container className="Paragraph Quote__margin">
      <div className="row">
        <div className="ParagraphQuote">
          <Quote body={body} imageSrc={image} imageAlt={imageAlt} name={name} jobTitle={jobTitle} link={linkUri} linkTitle={linkTitle} />
        </div>
      </div>
    </Container>
  );
};

export default ParagraphQuote;
